import React from 'react';
import { DashboardControl, ResourceManager } from 'devexpress-dashboard';
import './DashboardComponent.css'
import { connect } from 'react-redux';
import task from '../../../images/icons/task.png';
import folder from '../../../images/icons/folder.png';
import FetchData from '../../Utils/FetchData';

class DashboardComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            taskname: '',
            foldername: '',
            contextselection: '',
            reportname: '',
            createdby: ''

        };
        ResourceManager.embedBundledResources();
    }

    async componentDidMount() {
        this.props.history.push('./dashboard');
        const query = new URLSearchParams(this.props.location.search)
        var Roleid = query.get('roleid')
        var Taskid = query.get('taskid')
        var Userid = query.get('userid')
        var Folderid = query.get('folderid')
        var Dashboardid = query.get('dashboardid')
        var Taskname = query.get('taskname')
        var Reportname = query.get('reportname')
        var Createdby = query.get('createdby')

        var Foldername = query.get('foldername')
        var Contextselection = query.get('contextselection')
        this.setState({
            taskname: Taskname,
            foldername: Foldername,
            contextselection: Contextselection,
            reportname: Reportname,
            createdby: Createdby

        })
        var perms = (await FetchData('/api/showanalytics/DashboardUserPermissions/' + Userid)).data

        var postparameters;
        if (this.props.contextSelectionState !== undefined) {

            //var contextSelection = this.props.contextSelectionState.map((c) => '{' + c.id + '}:{' + c.beid + '}').join(',')
            //var contextRoots = this.props.contextSelectionState.map((c) => c.root).join(':')
            //var contextParents = this.props.contextSelectionState.map((c) => c.parent).join(':')
            var contextSelection = query.get('contextSelection')
            var contextRoots = query.get('contextRoots')
            var contextParents = query.get('contextParents')

            postparameters = "{'parameters':[\
                        {'name':'<CURRENTUSER>','value':'"+ Userid + "','pType':'i' },\
                        {'name':'<CURRENTTASK>','value':'"+ Taskid + "','pType':'i' },\
                        {'name':'<CURRENTROLE>','value':'"+ Roleid + "','pType':'i' },\
                        {'name':'<USERCONTEXTTEMPLATE>','value':'"+ this.props.contextTemplateIdState + "','pType':'as' },\
                        {'name':'<USERROOTCONTEXTSELECTION>','value': '"+ contextRoots + "','pType':'as' },\
                        {'name':'<USERPARENTCONTEXTSELECTION>','value': '"+ contextParents + "','pType':'as' },\
                        {'name':'<USERCONTEXTSELECTION>', 'value': '"+ contextSelection + "', 'pType': 'as' } \
                    ]}";
        } else {
            postparameters = "{'parameters':[\
                        {'name':'<CURRENTUSER>','value':'"+ Userid + "','pType':'i' },\
                        {'name':'<CURRENTTASK>','value':'"+ Taskid + "','pType':'i' },\
                        {'name':'<CURRENTROLE>','value':'"+ Roleid + "','pType':'i' },\
                        ]}";
        }

        this.dashboardControl = new DashboardControl(this.refs.dashboardcontainer, {
            endpoint: window.Configs.APIURL + "/api/dashboard",
            initialDashboardId: Dashboardid,
            workingMode: perms.isViewerOnly ? 'Viewer' : 'Designer',
            allowSwitchToDesigner: !perms.isViewerOnly,
            ajaxRemoteService: {
                headers: {
                    'Bearer': localStorage.getItem('authToken'),
                    'Params': postparameters,
                    'Uid': Userid,
                    'Fid': Folderid

                }
            },
            extensions: {
                "mobile-layout": {
                    mobileLayoutEnabled: "Auto",
                }
            }
        });
        this.dashboardControl.render();
    }

    componentWillUnmount() {
        this.dashboardControl.dispose();
    }

    render() {
        var tasknameHeader = this.state.taskname
        var foldernameHeader = this.state.foldername
        var contextselectionHeader = this.state.contextselection
        var reportnameHeader = this.state.reportname
        var createdbyHeader = this.state.createdby

        return (
            <div style={{ position: 'absolute', top: '0px', left: '0px', right: '0px', bottom: '0px' }}>
                <section className="content-header" style={{ marginTop: '7px', fontSize: '14px' }}>
                    <h1 style={{ fontSize: '14px' }}>

                        <img style={{ marginTop: '0px', marginLeft: '0px', height: '22px', width: '22px', fontSize: '14px' }} src={task} />
                        {tasknameHeader}
                        <img style={{ marginTop: '0px', marginLeft: '3px', height: '22px', width: '22px', fontSize: '14px' }} src={folder} />
                        {foldernameHeader}
                        <br />
                        <span style={{ fontSize: '14px', width: '20%' }}>Context: {contextselectionHeader}</span><br />

                        <span style={{ fontSize: '14px', width: '100%', marginLeft: '45%' }}>Name:{reportnameHeader}</span> <br /><span style={{ fontSize: '14px', width: '100%', marginLeft: '45%' }}>Created By: {createdbyHeader}</span>


                    </h1>


                </section>
                <div ref="dashboardcontainer" style={{ width: '100%', height: '90%' }}></div>

            </div>
        );
    }
}
const mapStateToProps = state => {
    return {

        contextTemplateIdState: state.contextTemplateDataId,
        contextSelectionState: state.contextSelection,

    }
};


export default connect(mapStateToProps, null)(DashboardComponent);



// WEBPACK FOOTER //
// ./src/components/TaskView/WorkPlace/DashboardComponent.js